import React, { useContext } from 'react';
import {
  Box,
  Flex,
  IconButton,
  Heading,
  Button,
  VStack,
  HStack,
  Image
} from '@chakra-ui/react';
import Logo from '../../assets/LogoVector.svg';
import { AuthContext } from '@/context/AuthContext';
import { useLocation } from 'react-router';
import { transformPathname } from '@/utils/common';

const Header = () => {
    const { logout } = useContext(AuthContext);
    const { pathname } = useLocation();

    return (
        <Box w="100%" as={HStack} h={"var(--headerHeight)"}>
            <HStack w={{ sm: 200, xl: 270 }} justify='center'>
                <Image src={Logo} w={90}/>
            </HStack>
            <HStack alignItems="center" justifyContent="space-between" px={5} flex='1'>
                <Heading size="md" color='text.subtle'>
                    {transformPathname(pathname)}
                </Heading>
                <Button variant="ghost" color='primary' onClick={logout} mr={{sm: 14, xl: 24}}>
                    LOG OUT
                </Button>
            </HStack>
        </Box>
    );
};

export default Header;